module.exports = __webpack_public_path__ + "static/media/panorama-v.926d469c.svg";